import { useEffect, useRef, useState } from "react";

// dropdown "Filtrar por status" — mesmo visual do AssortmentSelect (shared/index.jsx)
export const StatusFilterSelect = ({ options, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  const selected = options.find((opt) => opt.value === value);

  return (
    <div ref={rootRef} style={{ position: "relative" }}>
      <button onClick={() => setOpen((o) => !o)} style={{
        display: "flex", alignItems: "center", gap: 8, padding: "7px 12px",
        border: `1px solid ${open ? "#E8773A" : "#ddd"}`, borderRadius: "8px",
        background: "#fff", cursor: "pointer", fontSize: "13px", fontWeight: "700", color: "#333",
        minWidth: 170, justifyContent: "space-between",
      }}>
        <span>{selected ? `${selected.label} (${selected.count})` : "Todos"}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
          strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>
          <polyline points="6,9 12,15 18,9" />
        </svg>
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, minWidth: 210,
          background: "#fff", border: "1px solid #e0e0e0", borderRadius: "10px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.1)", zIndex: 100, padding: "6px 0",
        }}>
          {options.map((opt) => {
            const isActive = opt.value === value;
            return (
              <button key={opt.value} onClick={() => { onChange(opt.value); setOpen(false); }} style={{
                width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "7px 14px", background: isActive ? "#fff6f0" : "none", border: "none",
                cursor: "pointer", fontSize: "13px", color: isActive ? "#E8773A" : "#333",
                fontWeight: isActive ? "700" : "400", textAlign: "left",
              }}>
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  {isActive && <span style={{ width: 5, height: 5, borderRadius: "50%", background: "#E8773A", display: "inline-block" }} />}
                  {opt.label}
                </span>
                <span style={{ color: "#bbb", fontSize: "12px", fontWeight: "500" }}>({opt.count})</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
